module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN307_2128063055.7d4ae2f4.png";